import MDButton from "../components/MDButton";

function MyMDButton(props: any) {
  return <MDButton {...props} />;
}

export default MyMDButton;
